/**
 * Utilidades para manejar el campo `descripcion` de Transaccion.
 *
 * Las transacciones de Factura ARCA guardan la descripcion como un array JSON:
 *   [{ descripcion, monto, porcentajeIva }, ...]
 *
 * Las transacciones antiguas o de otros tipos guardan texto plano.
 * Estas funciones detectan el formato y lo manejan de forma transparente.
 */

/**
 * Parsea la descripcion de una transaccion.
 * Si es JSON de Factura ARCA devuelve el array; sino devuelve null.
 */
export function parsearDescripcionFactura(descripcion) {
    if (!descripcion || typeof descripcion !== "string") return null
    const trimmed = descripcion.trim()
    if (!trimmed.startsWith("[")) return null
    try {
      const parsed = JSON.parse(trimmed)
      if (Array.isArray(parsed)) return parsed
      return null
    } catch {
      return null
    }
  }
  
  /**
   * Devuelve la descripcion lista para mostrar al usuario.
   * - Si es JSON de Factura ARCA: concatena las descripciones de cada item.
   * - Si es texto plano: lo devuelve tal cual.
   * - Si está vacío: devuelve el fallback.
   */
  export function formatearDescripcionTransaccion(descripcion, fallback = "-") {
    if (!descripcion) return fallback
    const items = parsearDescripcionFactura(descripcion)
    if (items) {
      return items.map((it) => it.descripcion || "").filter(Boolean).join(" / ") || fallback
    }
    return descripcion || fallback
  }
  
  /**
   * Devuelve un array de líneas formateadas para mostrar en detalle:
   * - Si es JSON: una línea por servicio con descripcion, monto e IVA.
   * - Si es texto plano: un array con la descripcion completa.
   */
  export function detallarDescripcionTransaccion(descripcion) {
    if (!descripcion) return []
    const items = parsearDescripcionFactura(descripcion)
    if (items) {
      return items.map((it) => {
        const monto = it.monto != null ? `$ ${Number(it.monto).toLocaleString("es-AR")}` : ""
        const iva = it.porcentajeIva != null ? `IVA ${it.porcentajeIva}%` : ""
        return [it.descripcion, monto, iva].filter(Boolean).join(" — ")
      })
    }
    return descripcion ? [descripcion] : []
  }
  